import { Outlet } from 'react-router-dom';

import ConnectionIssueNotice from '../features/connection-status/ConnectionIssueNotice';

export default function AuthenticatedAppShell() {
  return (
    <>
      <ConnectionIssueNotice />
      <Outlet />
    </>
  );
}
